export const RequestType=
{
  AddEngagement: 'Add Engagement',
  RemoveEngagement:'Remove Engagement',
  AddModule:'Add Module',
  RemoveModule:'Remove Module',
  AddUser:'Add User',
  RemoveUser:'Remove User',
  ModifyUser:'Modify User',
}
